import { useGlobalStore } from '@/stores/globalStore'

export const usePopup = () => {
  const globalStore = useGlobalStore()

  const open = () => {
    globalStore.isShowPopup = true
  }

  const close = () => {
    globalStore.isShowPopup = false
  }

  const toggle = () => {
    globalStore.isShowPopup = !globalStore.isShowPopup
  }

  return { open, close, toggle }
}
